const useCommentsStore = (set) => ({
  comments: [],
  setComments(comments) {
    set({ comments });
  },
});

export default useCommentsStore;
